import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import Item from 'modules/contracts/components/ContractDetails/LegalAndLabour/Item'
import { activityTypes } from 'modules/contracts/lib/germanContractData'

interface Props {
  activityTypeId?: number | null
}

const ActivityType = ({ activityTypeId }: Props) => {
  const activityType = activityTypeId ? activityTypes()[activityTypeId] : undefined

  return (
    <Item
      title={i18n.t('contract_versions.legal_and_labour.germany.activity_type')}
      description={activityType}
    />
  )
}

export default observer(ActivityType)
